import Vue from 'vue'
import VueRouter from 'vue-router'

import User from './user'
import Profile from './profile'
import Unit from './unit'
import TypeUnit from './type_unit'
import VideoWall from './video_wall'
import Type from './types'
import Reason from './reasons'
import MedicalAgreement from './medical_agreements'
import Occurrence from './occurrences'
import EntrandeDoor from './entrance_doors'
import Agency from './agency'
import LogAccess from './log_access'
import Suport from './suport'
import Report from './report'
import Team from './team'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    User,
    Profile,
    Unit,
    TypeUnit,
    VideoWall,
    Type,
    Reason,
    MedicalAgreement,
    Occurrence,
    EntrandeDoor,
    Agency,
    LogAccess,
    Suport,
    Report,
    Team,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const access_nivel = localStorage.getItem('access_nivel');
  const authenticated = localStorage.getItem('token');
  let to_splited = to.path.toString().split('/')
  to_splited = to_splited.filter(part => part !== '')

  if (
    !authenticated &&
    (
      !(['/login'].includes(to.path.toString())) &&
      !(['public'].includes(to_splited[0]))
    )
  ) {
    next('/login');

    return true;
  }

  if (to.meta.access_nivel) {
    if (!to.meta.access_nivel.includes(access_nivel)) {
      next('/');
    }
  }

  next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
